<template>
	<div>
		<h5>IntegratedDispatching</h5>
	</div>
</template>

<script>
	export default {
		name: "IntegratedDispatching",
	};
</script>

<style scoped></style>
